var _rect, _mask, _rect2, _line, _mask2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "url(#paint0_linear_105_178)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_105_178",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.00002,
    y: 12.0288,
    width: 15,
    height: 10.0962,
    rx: 1.17188
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.00002,
    y: 12.0288,
    width: 15,
    height: 10.0962,
    rx: 1.17188,
    stroke: "white",
    strokeWidth: 3,
    mask: "url(#path-2-inside-1_105_178)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 19.3125,
    y1: 16.3269,
    x2: 21.1875,
    y2: 16.3269,
    stroke: "white",
    strokeWidth: 1.5
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_105_178",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 10.1719C9 9.52467 9.52467 9 10.1719 9H21.1875V13.0385H9V10.1719Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.1719C9 9.52467 9.52467 9 10.1719 9H21.1875V13.0385H9V10.1719Z",
    stroke: "white",
    strokeWidth: 3,
    mask: "url(#path-4-inside-2_105_178)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_105_178",
    x1: 0.748201,
    y1: 1.86047,
    x2: 50.4411,
    y2: 19.0061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.134603,
    stopColor: "#1489C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641968,
    stopColor: "#5BA532"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.de85c17584b66b73d0d45a602a4d944c.svg";
export { ForwardRef as ReactComponent };